module.exports = __webpack_public_path__ + "static/media/ingham-institute.fba18477.png";